/********************************************************************************************                              
* Module Name           : pricing-page-ui
* Author                : Ricky Nguyen  
* Date Created          : 2025-02-08 09:59:36                                    
* Description           : This module will handle interactive features on the pricing page.
*                         These code is specifically written to work with WP Kadence blocks.
*                         These codes assumed that default page settings has already been set,
*                         Example of these dafault setting includes class names and page visibility settings.
*            
*                                                     
*                                COPYRIGHT 2025 | ANACA
*********************************************************************************************/

// Get collection of nav buttons of pricing plans
const gbtnGrpMain = document.querySelectorAll(".btn-grp-main .btn");
const gbtnGrpCompTrust = document.querySelectorAll(".btn-grp__comp-trust .btn");
const gbtnGrpBookkeeping = document.querySelectorAll(".btn-grp__bookkeeping .btn");

// Get collection of content blocks
const gcolPricingWrapper = document.querySelectorAll(".pricing-wrapper");  //Wrapper of main pricing plans
const gcolCompTrustPricingPlans = document.querySelectorAll(".comp-trust-pricing-col .price-plan-wrapper"); //Company and Trust Pricing Plans
const gcolBookkeepingPricingPlans = document.querySelectorAll(".bookkeeping-pricing-col .price-plan-wrapper"); //Company and Trust Pricing Plans


// Make buttons interative via event listeners
gbtnGrpMain.forEach((element) => {
  element.addEventListener("click", handleMainButtonClick);
});

gbtnGrpCompTrust.forEach((element) => {
  element.addEventListener("click", handleBtnGroupCompTrustClick);
});

gbtnGrpBookkeeping.forEach((element) => {
  element.addEventListener("click", handleBtnGroupBookkeepingClick);
});

/**********************************************************************
* Function          : handleMainButtonClick
* Description       : Main nav buttons in Pricing Page
* Parameters        : e: the clicked element
* Return            : 
*----------------------------------------------------------------------
*                         Change History
*----------------------------------------------------------------------
*  Date               | Who                | Comment
*----------------------------------------------------------------------
*  2025-02-09         | Ricky              | Created
***********************************************************************/
function handleMainButtonClick(e) {

  // Reset buttons statuses
  clearActiveStatus(gbtnGrpMain);

  // Get clicked element
  let elButton = e.currentTarget;

  // Set active state for clicked button
  elButton.classList.add("active");

  // Check in class name list to determine which button was clicked.
  // We will expect only 1 of these to be true.
  let blnHasClassCompTrust = Object.values(elButton.classList).indexOf("btnCompTrust") > -1;
  let blnHasClassSoleTdPtship = Object.values(elButton.classList).indexOf("btnSoleTdPtship") > -1;
  let blnHasClassInvestment = Object.values(elButton.classList).indexOf("btnInvestment") > -1;
  let blnHasClassBookkeeping = Object.values(elButton.classList).indexOf("btnBookkeeping") > -1;
  let blnHasClassSmsf = Object.values(elButton.classList).indexOf("btnSmsf") > -1;
  let blnHasClassOtherServices = Object.values(elButton.classList).indexOf("btnOtherServices") > -1;

  // Reset display by hiding all content blocks
  resetDisplay(gcolPricingWrapper);
  
  
  // Make content block visible based on which button was clicked.
  if (blnHasClassCompTrust) {
      document.querySelectorAll(".pricing-wrapper__comp-trust")[0].setAttribute( 'style', 'display: flex !important; flex-direction: column');
  } 
  else if (blnHasClassSoleTdPtship) {
    document.querySelectorAll(".pricing-wrapper__soletraders-ptship")[0].setAttribute( 'style', 'display: flex !important; flex-direction: column');
  }
  else if (blnHasClassInvestment) {
    document.querySelectorAll(".pricing-wrapper__investment")[0].setAttribute( 'style', 'display: flex !important; flex-direction: column');
  }
  else if (blnHasClassBookkeeping) {
    document.querySelectorAll(".pricing-wrapper__bookkeeping")[0].setAttribute( 'style', 'display: flex !important; flex-direction: column');
  }
  else if (blnHasClassSmsf) {
    document.querySelectorAll(".pricing-wrapper__smsf")[0].setAttribute( 'style', 'display: flex !important; flex-direction: column');
  } else if (blnHasClassOtherServices) {
    document.querySelectorAll(".pricing-wrapper__other-services")[0].setAttribute( 'style', 'display: flex !important; flex-direction: column');
  }
  
}

/**********************************************************************
* Function          : handleBtnGroupCompTrustClick
* Description       : Supplementary nav buttons for Company and Trust pricing plans
* Parameters        : e: the clicked element
* Return            : 
*----------------------------------------------------------------------
*                         Change History
*----------------------------------------------------------------------
*  Date               | Who                | Comment
*----------------------------------------------------------------------
*  2025-02-09         | Ricky              | Created
***********************************************************************/
function handleBtnGroupCompTrustClick(e) {
  
  // Reset buttons statuses
  clearActiveStatus(gbtnGrpCompTrust);

  // Get clicked element
  let elButton = e.currentTarget;

  // Set active state for clicked button
  elButton.classList.add("active");

  // Reset display by hiding all content blocks
  resetDisplay(gcolCompTrustPricingPlans);

  // Check in class name list to determine which button was clicked.
  // We will expect only 1 of these to be true.
  var blnHasClassPriceSize1 = Object.values(elButton.classList).indexOf("btnPriceSize1") > -1;
  var blnHasClassPriceSize2 = Object.values(elButton.classList).indexOf("btnPriceSize2") > -1;
  var blnHasClassPriceSize3 = Object.values(elButton.classList).indexOf("btnPriceSize3") > -1;

  // Make content block visible based on which button was clicked.
  if (blnHasClassPriceSize1) {
    document.querySelectorAll(".pricing-wrapper__comp-trust .price-plan1")[0].setAttribute( 'style', 'display: flex !important; flex-direction: column');
  } else if (blnHasClassPriceSize2) {
    document.querySelectorAll(".pricing-wrapper__comp-trust .price-plan2")[0].setAttribute( 'style', 'display: flex !important; flex-direction: column');
  }else if (blnHasClassPriceSize3) {
    document.querySelectorAll(".pricing-wrapper__comp-trust .price-plan3")[0].setAttribute( 'style', 'display: flex !important; flex-direction: column');
  }

}

/**********************************************************************
* Function          : handleBtnGroupBookkeepingClick
* Description       : Supplementary nav buttons for Bookkeeping pricing plans
* Parameters        : e: the clicked element
* Return            : 
*----------------------------------------------------------------------
*                         Change History
*----------------------------------------------------------------------
*  Date               | Who                | Comment
*----------------------------------------------------------------------
*  2025-02-09         | Ricky              | Created
***********************************************************************/
function handleBtnGroupBookkeepingClick(e) {
  // Reset buttons statuses
  clearActiveStatus(gbtnGrpBookkeeping);

  // Get clicked element
  let elButton = e.currentTarget;

  // Set active state for clicked button
  elButton.classList.add("active");

  // Reset display by hiding all content blocks
  resetDisplay(gcolBookkeepingPricingPlans);

  // Check in class name list to determine which button was clicked.
  // We will expect only 1 of these to be true.
  var blnHasClassPriceSize1 = Object.values(elButton.classList).indexOf("btnPriceSize1") > -1;
  var blnHasClassPriceSize2 = Object.values(elButton.classList).indexOf("btnPriceSize2") > -1;

  // Set visibility of supplementary button group
  if (blnHasClassPriceSize1) {
    document.querySelectorAll(".pricing-wrapper__bookkeeping .price-plan1")[0].setAttribute( 'style', 'display: flex !important; flex-direction: column');
  } else if (blnHasClassPriceSize2) {
    document.querySelectorAll(".pricing-wrapper__bookkeeping .price-plan2")[0].setAttribute( 'style', 'display: flex !important; flex-direction: column');
  }

}


/**********************************************************************
* Function          : clearActiveStatus
* Description       : This is a helper function to clear active class from all buttons
* Parameters        : col (Obj HtmlCollection)
* Return            : 
*----------------------------------------------------------------------
*                         Change History
*----------------------------------------------------------------------
*  Date               | Who                | Comment
*----------------------------------------------------------------------
*  2025-02-09         | Ricky Nguyen       | Created
***********************************************************************/
function clearActiveStatus(col) {
  col.forEach((element) => {
      element.classList.remove("active");
    });
}

/**********************************************************************
* Function          : resetDisplay
* Description       : This is a helper function to hide all content blocks
* Parameters        : col (Obj HtmlCollection)
* Return            : 
*----------------------------------------------------------------------
*                         Change History
*----------------------------------------------------------------------
*  Date               | Who                | Comment
*----------------------------------------------------------------------
*  2025-02-09         | Ricky Nguyen       | Created
***********************************************************************/
function resetDisplay(col) {
  col.forEach((element) => {
    element.setAttribute( 'style', 'display: none !important' );
  });
}
